//
//
//
//
//
//
//

export default {
  name: "VocStatus",
  props: {
    text: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    }
  }
}
